import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import {
	type ApplicationEdition,
	FREE_EDITION,
	PREMIUM_EDITION,
	STANDARD_EDITION,
} from '@atlassian/jira-shared-types';
import messages from './messages';

type EditionAwarenessLabelProps = {
	edition: ApplicationEdition;
	inGracePeriod?: boolean;
};

function getMessage(edition: ApplicationEdition, inGracePeriod: boolean) {
	switch (edition) {
		case FREE_EDITION:
			return messages.freeLabel;
		case STANDARD_EDITION:
			return !inGracePeriod ? messages.standardLabel : messages.gracePeriodStandardLabel;
		case PREMIUM_EDITION:
			return !inGracePeriod ? messages.premiumLabel : messages.gracePeriodPremiumLabel;
		default:
			throw Error(`Missing label for edition ${edition}`);
	}
}

export function EditionAwarenessLabel(props: EditionAwarenessLabelProps) {
	const { edition, inGracePeriod = false } = props;

	const { formatMessage } = useIntl();

	return (
		<LabelContainer data-testid="navigation-apps-sidebar-edition-awareness.common.ui.edition-awareness-label.edition-awareness-free-pill-label">
			{formatMessage(getMessage(edition, inGracePeriod))}
		</LabelContainer>
	);
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LabelContainer = styled.div({
	color: token('color.text.subtle', '#44546F'),
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
	fontSize: '12px',
	fontWeight: '600',
	textOverflow: 'ellipsis',
	overflow: 'hidden',
	whiteSpace: 'nowrap',
	maxWidth: '100%',
});
